import React, {PureComponent} from 'react';
import {Redirect} from 'react-router-dom'
import {connect} from 'react-redux';

import {setFieldValueGen} from '../helpers/utils';
import {Button, Form, FormGroup, Label} from 'reactstrap'
import Input from '../components/Input'
import {userLogin} from '../actions/AuthActions'
import {getErrorMessage} from '../helpers/errors'

class LoginScreen extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {isSubmitting: false, errors: [], template: {email: '', password: ''}};
    this.setFieldValue = setFieldValueGen(this, 'template');
  }

  handleSubmit = async evt => {
    evt.preventDefault();
    const {email, password} = this.state.template;

    try {
      this.setState({isSubmitting: true, errorMessage: null});
      await this.props.dispatch(userLogin(email, password));
      this.props.history.push('/');
    } catch (err) {
      console.log('err=', err);
      const errorMessage = getErrorMessage(err);
      this.setState({isSubmitting: false, errorMessage});
    }
  };

  render() {
    if (this.props.isLoggedIn) return <Redirect to="/"/>

    const inputFields = this.renderFields();

    return (
      <form className="login-form card" onSubmit={this.handleSubmit}>
        <img alt="Logo" src="/static/img/logo-lg.png"/>

        <p className="login-help">Digite suas credenciais para acessar o <strong>GoKids Admin</strong></p>
        {inputFields}

        {!!this.state.errorMessage && (
          <p className="text-danger text-center">
            <small>{this.state.errorMessage}</small>
          </p>
        )}
        <button
          type="submit"
          className="btn btn-primary"
          disabled={this.state.isSubmitting}>
          ENTRAR
        </button>
      </form>
    );
  }

  renderFields() {
    const {template} = this.state;

    return (
      <div>
        <div className="form-group">
          <Input
            type="email"
            name="email"
            placeholder="Digite seu e-mail"
            value={template.email}
            onChange={this.setFieldValue}/>
        </div>
        <div className="form-group">
          <Input
            type="password"
            name="password"
            placeholder="Digite sua senha"
            value={template.password}
            onChange={this.setFieldValue}/>
        </div>
      </div>
    );
  }
}

export default connect(state => ({
  isLoggedIn: !!state.user.token,
}))(LoginScreen);



// WEBPACK FOOTER //
// ./src/screens/LoginScreen.js